import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LabelService {
  private existingLabels: { [key: string]: number } = {};
  private freeNumbers: { [key: string]: number[] } = {};

    public get getExistingLabels(): { [key: string]: number } {
      return this.existingLabels;
    }
  
    public get getFreeNumbers(): { [key: string]: number[] } {
      return this.freeNumbers;
    }

  generateUniqueLabel(newLabel: string): string {
    const normalizedLabel = newLabel.trim().toLowerCase();
    const { baseLabel, numberSuffix } = this.extractBaseLabelAndNumber(normalizedLabel);

    if (this.freeNumbers[baseLabel] && this.freeNumbers[baseLabel].length > 0) {
      const index = this.freeNumbers[baseLabel].indexOf(numberSuffix);

      if (index !== -1) {
        this.freeNumbers[baseLabel].splice(index, 1);
        return numberSuffix > 0 
          ? this.formatLabel(baseLabel, numberSuffix)
          : this.formatLabel(baseLabel);
      } else {
        const reuseNumber = this.freeNumbers[baseLabel].shift();
        return reuseNumber > 0 
          ? this.formatLabel(baseLabel, reuseNumber)
          : this.formatLabel(baseLabel);
      }
    }

    if (this.existingLabels[baseLabel] === undefined) {
      if (numberSuffix > 0) {
        this.fillFreeNumbers(baseLabel, numberSuffix);
      }
    }

    if (this.existingLabels[baseLabel] !== undefined) {
      if (this.existingLabels[baseLabel] < numberSuffix) {
        this.fillFreeNumbers(baseLabel, numberSuffix);
        this.existingLabels[baseLabel] = numberSuffix;
        return this.formatLabel(baseLabel, numberSuffix);
      } else if (this.existingLabels[baseLabel] === numberSuffix) {
        this.existingLabels[baseLabel] = numberSuffix + 1;
        return this.formatLabel(baseLabel, numberSuffix + 1);
      } else {
        this.existingLabels[baseLabel]++;
        const newNumber = this.existingLabels[baseLabel];
        return this.formatLabel(baseLabel, newNumber);
      }
    } else {
      this.existingLabels[baseLabel] = numberSuffix;
      return numberSuffix > 0 
        ? this.formatLabel(baseLabel, numberSuffix)
        : this.formatLabel(baseLabel);
    }
  }

  removeLabelFromExistingLabels(
    label: string
  ): void {
    const { baseLabel, numberSuffix } = this.extractBaseLabelAndNumber(label);
    
    if (
      this.existingLabels[baseLabel] !== undefined
    ) {
      if (!this.freeNumbers[baseLabel]) {
        this.freeNumbers[baseLabel] = [];
      }
      this.freeNumbers[baseLabel].push(numberSuffix);
      this.freeNumbers[baseLabel].sort((a, b) => a - b);
    }
  }

  private extractBaseLabelAndNumber(
    label: string
  ): { baseLabel: string, numberSuffix: number } {
    const match = label.match(/(.*?)(\d+)$/);
    
    if (match) {
      return {
        baseLabel: match[1].trim().toLowerCase(),
        numberSuffix: parseInt(match[2], 10)
      };
    } else {
      return {
        baseLabel: label.trim().toLowerCase(),
        numberSuffix: 0
      };
    }
  }

  private formatLabel(
    baseLabel: string, 
    numberSuffix?: number
  ): string {
    const formattedBase = baseLabel.charAt(0).toUpperCase() + baseLabel.slice(1);
    return numberSuffix !== undefined 
      ? `${formattedBase} ${numberSuffix}` 
      : formattedBase;
  }

  private fillFreeNumbers(
    baseLabel: string, 
    numberSuffix: number
  ): void {
    for (let i = this.existingLabels[baseLabel] + 1 || 0; i < numberSuffix; i++) {
      if (!this.freeNumbers[baseLabel]) {
        this.freeNumbers[baseLabel] = [];
      }
      this.freeNumbers[baseLabel].push(i);
    }
  }
}
